import { render, staticRenderFns } from "./AssignItemModal.vue?vue&type=template&id=510e1384&"
import script from "./AssignItemModal.vue?vue&type=script&lang=js&"
export * from "./AssignItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports